import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { MapService } from '../leaflet/service/map.service';

@Component({
    selector: 'app-map-layer-selector',
    templateUrl: './map-layer-selector.component.html',
    styleUrls: ['./map-layer-selector.component.scss'],
})
export class MapLayerSelectorComponent implements OnInit {
    layers = [
        { key: 'Fleet', name: 'Fleet' },
        { key: 'Dark Matter', name: 'Dark Matter' },
        { key: 'Google Hybrid', name: 'Google Hybrid' },
        { key: 'Google Sat', name: 'Google Satellite' },
        { key: 'Google Streets', name: 'Google Streets' },
        { key: 'OpenStreetMap', name: 'OpenStreetMap' }
    ];
    currentLayer: string;

    constructor(
        private popoverCtrl: PopoverController,
        private mapService: MapService
    ) { }

    ngOnInit() {
        this.currentLayer = this.mapService.resolveMapLayerKey();
    }

    selectLayer(layerKey: string) {
        if (this.currentLayer === layerKey) {
            this.popoverCtrl.dismiss();
            return;
        }

        this.mapService.setSelectedMapLayer(layerKey);
        if (this.mapService.map) {
            this.mapService.applyMapLayerToMap(this.mapService.map, layerKey);
        }
        this.currentLayer = layerKey;
        this.popoverCtrl.dismiss(layerKey);
    }
}
